






































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";

/**
 * Components
 */
import BookingCalendar from "../booking/components/BookingCalendar.vue";
import ShopBrowser from "./components/ShopBrowser.vue";
import CartDetails from "./components/CartDetails.vue";
import SummaryPage from "./components/SummaryPage.vue";

/**
 * Utils
 */
import { getLocaleDateString } from "@/utils/date-helpers";
import { getFullName } from "@/utils/users-helpers";
import { sortByAsc } from "@/utils/sort-helpers";

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import cartAPI from "@/api/cart";
import bookingsAPI, { BookingCategory } from "@/api/bookings";
import usersAPI from "@/api/users";
import servicesAPI, { ModePassage } from "@/api/services";
import subscriptionsAPI from "@/api/subscriptions";

/**
 * Types
 */
import { Cart } from "./store";

/**
 * Page de réservation Click & Collect.
 */
@Component({
  components: { BookingCalendar, ShopBrowser, CartDetails, SummaryPage },
  mixins: [mixinsAPI]
})
export default class BookingShopPage extends Vue {
  $refs!: {
    calendar: BookingCalendar;
    ShopBro:ShopBrowser;
  };

  /** Injections */
  getLocaleDateString = getLocaleDateString;
  getFullName = getFullName;

  /** VueX - Snackbar */
  @Action("openInfo", { namespace: "snackbar" })
  openInfo: any;
  @Action("openError", { namespace: "snackbar" })
  openError: any;

  /** Attributs */
  isLoading = false;
  isActionLoading = false;

// watch caller
refreshItems=false;

 //@Prop()
  displayedCashItems:any[]| null=[] ;

  // TODO : à mettre dans un store
  dateBooked: Date | null = null;
  serviceBooked: any | null = null;
  userBooked: any | null = null;
  cart: Cart = new Cart();
  
  // Les usagers possibles
  users: any[] = [];

  // Les services possibles
  services: any[] = [];

  step: number = 1;

  get step1Ok() {
    return (
      this.dateBooked != null &&
      this.serviceBooked != null &&
      this.userBooked != null
    );
  }

  get nbItemsInCart() {
    return this.cart.nbItems;
  }

  /** Méthodes */
  async created() {
    this.isLoading = true;
    await this.loadFilterDefinitionsData();
    this.isLoading = false;
  }

  async loadFilterDefinitionsData() {
    const currentUser = await usersAPI.getCurrent();
    const currentUserChildren = await usersAPI.getChildrenForBooking();
      const services = await servicesAPI.GetAllReservable(ModePassage.SHOP);

  // this.users = [currentUser, ...currentUserChildren];
      const bookableUser = await usersAPI.getUsersForBooking();
      this.users = [...bookableUser];

      


    this.services = services.sort(sortByAsc(x => x.label));
   
  }

  async handleBookClick(date: Date, userID: number, serviceID: number) {
    this.dateBooked = date;
    this.userBooked = this.users.find(x => x.id === userID);
    this.serviceBooked = this.services.find(x => x.id === serviceID);

    this.step = 2;
       await this.$refs.ShopBro.reloadItems();
  }

  async handleMoreClick(booking: any) {
    this.$router.push(`booking_shop/${booking.id}`);
  }

  async fetchMonthBookableDates(month: number, year: number) {
    return await bookingsAPI.getAllowedMonthBookableDates(
      month,
      year,
      BookingCategory.SHOP
    );
  }

  async fetchMonthBookings(month: number, year: number) {
    return await bookingsAPI.getAll(year, month, null, BookingCategory.SHOP);
  }

  async handleItemAdd(itemId: number, itemType: number) {//AL todo sup itemtype
    const itemInCart = this.cart.items.find(x => x.id === itemId && x.formulaNumber == null);
    // if (itemType == 2) {alert ("formule");}
    if (itemInCart == null) {
      this.cart.items.push({ id: itemId, quantity: 1, formulaNumber: null, item: null, targetDate:this.dateBooked,remaining:0  });
    } else {
      itemInCart.quantity += 1;
    }

    await this.refreshCartFromServer();


  await this.$refs.ShopBro.reloadItems();
  }

//gestion de l'adjonction des formules et de sa composition
  async handleFormulaAdd(itemId: number, items: any[]) {
    let TmpFormulaNum = 1;
    // recup d'un identifiant de formule pour la liason
    let formulaInCart = this.cart.items.filter(x => x.item.cashItemType == 2);
    
    if (formulaInCart != null && formulaInCart.length > 0) {
    formulaInCart.sort((x, y) => (x.formulaNumber != null ? x.formulaNumber:0 ) - (y.formulaNumber!= null ? y.formulaNumber:0));
    
     TmpFormulaNum =  (formulaInCart[formulaInCart.length - 1].formulaNumber != null ?  Number( formulaInCart[formulaInCart.length - 1].formulaNumber  ) + 1 : TmpFormulaNum );
   
  }
  
	//enregistrement de la formule
  this.cart.items.push({ id: itemId, quantity: 1, formulaNumber: TmpFormulaNum ,item: null, targetDate:this.dateBooked,remaining:0 });
  for(let elem of items ){
    this.cart.items.push({ id: elem.id, quantity: 1, formulaNumber: TmpFormulaNum ,item: null, targetDate:this.dateBooked,remaining:0  });
  }
    await this.refreshCartFromServer();
  }




  async handleItemRemove(itemId: number,formulaNum: number|null) {
 
    const itemInCart = this.cart.items.find(x => x.id === itemId &&  (x.formulaNumber == null||(x.item.cashItemType== 2 && x.formulaNumber== formulaNum)));
    if (itemInCart != null) {
      itemInCart.quantity -= 1;
  if (itemInCart.formulaNumber!=null){
    for(let elem of this.cart.items){
        if (elem.formulaNumber == itemInCart.formulaNumber){elem.quantity =0;}
    }
  }

    }
    this.cart.items = this.cart.items.filter(x => x.quantity > 0);

    await this.refreshCartFromServer();
     await this.$refs.ShopBro.reloadItems();
  }

  resetBooking() {
    this.serviceBooked = null;
    this.dateBooked = null;
    this.userBooked = null;
    this.resetCart();
  }

  async resetCart() {
    this.cart.items = [];
    await this.refreshCartFromServer();
  }

  async refreshCartFromServer() {
    for(let elem of this.cart.items){
      elem.targetDate = this.dateBooked;
    }
    const cartDetails = await cartAPI.getCartDetails(this.cart.items);
   
    this.cart = Object.assign(new Cart(), cartDetails);
    }

  /**
   * Callback lorsqu'on clique sur "Valider la commande" : crée la réservation sur le serveur.
   */
  async validateCommand() {
    if (this.dateBooked == null) {
      return;
    }
    this.isActionLoading = true;
    try {
      await bookingsAPI.createWithCart({
        serviceID: this.serviceBooked.id,
        bookedDate: this.dateBooked,
        userID: this.userBooked.id,
        items: this.cart.items.map(x => ({ id: x.id, quantity: x.quantity , formulaNumber: x.formulaNumber}))
      });

      await this.$refs.calendar.reloadBookings();

      this.resetBooking();
      this.step = 1;

      this.openInfo(this.$t("snackbar.success"));
    } catch (err) {
      (this as any).handleAPIError(err);
    }
    this.isActionLoading = false;
  }

  /**
   * Callback lorsque l'on clique sur "Annuler" une réservation ou "Annuler" une déréservation.
   */
  async handleCancelClick(date: Date, userID: number, serviceID: number) {
    this.isActionLoading = true;
    try {
      await bookingsAPI.cancel({
        bookedDate: date,
        userID,
        serviceID,
        hasItems: true
      });

      await this.$refs.calendar.reloadBookings();

      this.openInfo(this.$t("snackbar.success"));
    } catch (err) {
      (this as any).handleAPIError(err);
    }
    this.isActionLoading = false;
  }
}
